<script lang="ts" setup>
import SessionList from '@kidzonet/sessions'
import SessionItem from '@kidzonet/sessions/src/Item.vue'
import { useClickOnCurrentMenuItemListener } from '@kidzonet/vue3-event-bus'

import { useSessionsStore } from './store'

const store = useSessionsStore()

const refreshData = () => {
    store.getSessions()
}

useClickOnCurrentMenuItemListener(refreshData)
refreshData()
</script>

<template>
    <SessionList
        :loading="store.isSessionLoading"
    >
        <template #item>
            <SessionItem
                v-for="item in store.sessions"
                :key="item.sessionId"
                :item="item"
                class="kidzonet-dashboard-widget"
                @delete-session="() => store.deleteSession(item.sessionId)"
            />
        </template>
    </SessionList>
</template>
